import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=90eb8198&scoped=true&v-if=this.statsData&"
import script from "./StatsCard.vue?vue&type=script&lang=js&"
export * from "./StatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eb8198",
  null
  
)

export default component.exports